export const supplierInternalGroups = ["Amministrazione", "Milkrun", "Magazzino", "Schedulazione", "Tecnici"];

export function isInternalSupplierUser(user) {
    return supplierInternalGroups.some(group => (user?.groups || []).includes(group));
}

export function supplierRouteDecision(loggedIn, user, ownArea = false) {
    if (!loggedIn) return "/login";
    if (isInternalSupplierUser(user)) return ownArea ? { name: "Fornitori" } : undefined;
    if ((user?.groups || []).includes("Fornitore")) return ownArea ? undefined : { name: "fornitore-magazzino" };
    return "/";
}
